import config from "config";

declare global {
    interface Window {
        turnstile: any;
    }
}

export function getCaptchaToken(): Promise<string> {
    return new Promise((res, rej) => {
        window.turnstile.render("#captcha", {
            sitekey: config.captcha.key,
            callback: function (token) {
                res(token)
            },
            "error-callback": function (error) {
                rej(error)
            }
        });
    })
}